<template>
  <v-dialog v-model="textDialog" width="440">
    <v-card height="188" class="justify-center align-center pt-5">
      <v-row class="ma-0 pa-0 text-center justify-center d-flex mt-5 mb-5">
        <span class="dialog-text mt-2" v-html="dialogText"> </span>
      </v-row>
      <v-row class="ma-0 pa-0 text-center justify-center d-flex mt-5 pt-5">
        <v-btn
          @click="$emit('actioneMethods')"
          class=" color-white ml-5"
          color="#739EEC"
          width="150"
          height="40"
          >확인</v-btn
        >
        <v-btn
          @click="$emit('dialogChange')"
          color="#FFFFFF"
          class="btn-ff5b5a ml-5"
          width="150"
          height="40"
          >취소</v-btn
        >
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["textDialog", "dialogStatus"],
  computed: {
    dialogText() {
      if (this.dialogStatus == "approvalCancel")
        return `승인 취소 시 미승인 상태로 변경되며,\n
     출고 및 입고 데이터는 삭제됩니다. 하시겠습니까?`;
      else if (this.dialogStatus == "delete")
        return "발주데이터가 삭제됩니다. 하시겠습니까?";
    },
  },
};
</script>
<style></style>
